import React, { Component } from 'react';
import './LoginStyle.css';

export default class LocationSubscriptionReminder extends Component {


    constructor(props) {
        super(props);
        
        this.state =
        {
        }
    }


    render() {
        
      
        return (
            <div>
                <table style={{ width: "400px" }}>
                    <tr>
                        <td align="center" style={{ paddingLeft: "10px", textAlign: "center" }}>
                            <span style={{ fontSize: "15px", color: "red", fontWeight: "bold", paddingLeft: "10px" }}>Subscription Reminder</span>
                        </td>
                    </tr>
                    <tr>
                        <td align="left" style={{ paddingLeft: "10px" }} >
                            <br />{this.props.LocSubscriptionMsg}<br />
                            <br />
                            Invoice has already been sent. Please make the payment at the<br />
                            earliest to avoid any disruption of the service.<br />
                            <br />
                            For any clarification, please contact to admin department on<br />
                            Tel: +91 22 4034 0000 or email to admin@softlinkglobal.com/<br />
                            accounts@softlinkglobal.com<br /><br />
                        </td>
                    </tr>
                    <tr>
                        <td align="center" style={{ paddingLeft: "10px", textAlign: "center" }}>
                            <input className="SButton" type="button" value="OK" onClick={this.props.closeSubReminder} />
                        </td>
                    </tr>
                </table>
            </div>
           
        );

    }
}
 